export enum INVENTORY_VIEW {
  EQUIPPED = '0',
  ALL = '1',
}
